module.exports = __webpack_public_path__ + "img/signal-app-widget.b205a4e1.png";